import { environment } from "@env/environment";
import {
	AngularCommonsLibelleConfiguration,
	CommonsConfigurationService,
} from "@jack-sparrow-libraries/angular-business-commons";
import { Injectable } from "@angular/core";

@Injectable()
export class CommonsConfigurationAgatheyouService implements CommonsConfigurationService {
	getUrlBackend(): string {
		return environment.apiEmotion();
	}
	getCpsBloqueLink(): string {
		return "https://intercom.help/milo-6f8b10/fr/articles/10959210-comment-debloquer-sa-carte-de-professionnel-de-sante-cps";
	}
	getLibelleConfig(): AngularCommonsLibelleConfiguration {
		return {
			ordonnance: "ordonnance",
			app: "Agathe You",
			filtreStatSoignant: "Infirmier",
		};
	}
	getDomain(): string {
		return "agatheyou.fr";
	}
}
